import { Button } from '@hyperflake/react-ui-library';
import { CircularProgress } from '@library/loaders/components';
import { Popover } from '@library/popover';
import { FC, ReactNode, useState } from 'react';
import ContentViewer from 'modules/shared/features/ContentViewer/ContentViewer';


interface DisplayImageViewProps {
    children: ReactNode;
    showRemove: boolean;
    onRemove: () => void;
    isUploading?: boolean;
    uploadProgress?: number;
}

const DisplayImageView: FC<DisplayImageViewProps> = (props) => {
    const { children, showRemove, onRemove, isUploading, uploadProgress } = props;
    const [showRemovePopver, setShowRemovePopver] = useState<boolean>(false);

    return (
        <div className='relative border border-separator-color rounded-full select-none'>
            {children}

            {showRemove && (
                 <>
               
                
                      <Popover
                          placement="bottom-start"
                          contentClassName="px-6 py-5 rounded-2xl shadow-lg w-[380px]"
                          open={showRemovePopver}
                          setOpen={setShowRemovePopver}
                          content={
                              <div>
                                  <p className="text-sm text-grayscale-500">
                                      Are you sure you want to remove image?
                                  </p>

                                  <div className="flex gap-3 mt-4">
                                      <Button
                                          
                                          size="xs"
                                          color="primary"
                                          onClick={()=>{
                                            setShowRemovePopver(false)
                                            onRemove()}}
                                      >
                                          Delete
                                      </Button>
                                      <Button onClick={() => setShowRemovePopver(false)} size="xs" variant="shaded">
                                          Cancel
                                      </Button>
                                  </div>
                              </div>
                          }
                      >
                         <div
                    className='absolute top-0 left-0 w-full h-full rounded-full flex items-center justify-center text-xs font-semibold text-white bg-black/40 cursor-pointer select-none transition-opacity duration-300 opacity-0 hover:opacity-100'
                  
                >
                    Remove
                </div>
                      </Popover>
               
             </>
            )}

            {isUploading && (
                <div className='absolute top-0 left-0 w-full h-full rounded-full flex items-center justify-center bg-white/80 text-primary select-none'>
                    <CircularProgress variant='indeterminate' size={88} />
                </div>
            )}
        </div>
    );
};

export default DisplayImageView;
